import { Separator } from '@/components/ui/separator'
import { formatCurrency } from '../../../../lib/utils'
import { InsurancePolicy } from '../../../../models/insurancePolicy'

/** Receipt tail of the policy card: each one-time fee, then the total. */
export function PolicyPremiumReceipt({ policy }: { policy: InsurancePolicy }) {
  // With no fees there is nothing to itemise, so the fee lines and their
  // divider drop out and the total follows the coverages directly.
  const hasFees = policy.oneTimeFees.length > 0

  return (
    <div className="flex flex-col gap-2">
      {hasFees && (
        <>
          {policy.oneTimeFees.map((fee) => (
            <ReceiptRow key={fee.id} label={fee.label} amount={fee.amount} />
          ))}
          {/* my-4 tops the gap-2 up to the card's 24px separator rhythm, so the
              fee lines sit the same distance from this divider as from the one
              above them. */}
          <Separator className="my-4" />
        </>
      )}
      <ReceiptRow label={hasFees ? 'Total (incl. fees)' : 'Total'} amount={policy.premium} emphasis />
    </div>
  )
}

function ReceiptRow({ label, amount, emphasis }: { label: string; amount: number; emphasis?: boolean }) {
  return (
    <div className="text-md flex items-baseline justify-between gap-4">
      <span className={emphasis ? 'font-semibold text-black' : 'text-muted-foreground font-medium'}>
        {label}
      </span>
      <span className={emphasis ? 'font-semibold text-black' : 'font-medium text-black'}>
        {formatCurrency(amount)}
      </span>
    </div>
  )
}
